export default "__VITE_ASSET__ac127005__"